import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetTokensPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.form-default-values';
import { GetTokensPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchTokenListContextProvider,
  useTokenListContext,
} from '../token.context';
import { TokenListFilterSearchFormController } from './token-list-filter-search-form/token-list-filter-search-form.controller';

interface TokenListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const TokenListFilterSearchController = ({
  onCancel,
  onSuccess,
}: TokenListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useTokenListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetTokensPaginatedModel> = (errors) => {
    Logger.error(errors);
    toast.error(
      t('$.token-list-filter-search.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetTokensPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetTokensPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterSearchTokenListContextProvider data={data}>
      <TokenListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchTokenListContextProvider>
  );
};
